const main = {
  radius: 7,
};

export default main;
